{
	"title": "nakazawa 🐇🥕🐰",
	"description": "🐇🥕🐰",
	"buttons": {
		"fullscreen": "Plein écran",
		"achievements": "Succès",
		"reset": "Réinitialiser",
		"language": "Langue"
	},
	"achievements": {
		"title": "Succès",
		"noAchievements": "Aucun succès débloqué. Continuez à cliquer !",
		"unlocked": "Succès débloqué : {{message}}",
		"progress": "{{progress}}%",
		"beginner": "🎯 Lapin Débutant",
		"carrotSnatcher": "🥕 Voleur de Légumes",
		"bunnyBerserker": "😡 Lapin Enragé",
		"hopPunk": "🎸 Lapin Anarchiste",
		"bunnyNinja": "🥷 Silencieux mais Mortel",
		"expert": "🌟 Sauteur Expert",
		"master": "👑 Roi des Carottes",
		"carrotpocalypse": "🥕 Destructeur de Potagers",
		"bunnyOverlord": "😈 Seigneur Suprême du Terrier",
		"chaosHare": "🌪️ Agent du Chaos",
		"carrotCultist": "⛪ Grand Prêtre du Culte de la Carotte",
		"bunnyberryPie": "🥧 Maître de la Tarte Hallucinogène",
		"rabbitHole": "🕳️ Creuseur de Tunnels Quantiques",
		"moonRabbit": "🌙 Lapin Lunaire",
		"bunnyDoom": "💀 Héraut du Lapocalypse",
		"carrotNuke": "☢️ Porteur de la Carotte Nucléaire",
		"bunnyMatrix": "🤖 Bug dans la Matrice Lapine",
		"cosmicHare": "🌌 Le Lièvre Cosmique S'éveille",
		"warrenSingularity": "🕳️ Singularité du Terrier Atteinte",
		"eternalBunny": "♾️ Le Lapin Éternel"
	},

	"messages": {
		"prophecy": "L'ancienne prophétie des clics commence à se dévoiler...",
		"cosmic": "Les cliqueurs cosmiques seraient fiers de vos progrès !",
		"astral": "Les clics résonnent à travers le plan astral...",
		"speaking": "Attendez... vous avez entendu ça ? Les clics me parlent...",
		"ancient": "Vos clics résonnent avec une puissance ancestrale !",
		"sages": "Les Sages du Clic murmurent votre potentiel...",
		"demons": "CONTEMPLEZ ! Les Démons du Clic s'éveillent de leur sommeil !",
		"veil": "Vos clics percent le voile de la réalité !",
		"spirits": "Les Esprits du Clic dansent à votre rythme...",
		"council": "Le Grand Conseil du Clic a remarqué votre dévouement",
		"primordial": "Vos clics réveillent des forces primordiales !",
		"void": "Le vide des clics vous regarde en retour...",
		"runes": "Les runes anciennes du clic brillent de votre puissance !",
		"beast": "TROIS TROIS TROIS - LE NOMBRE DE LA BÊTE DU CLIC",
		"prophets": "Les Prophètes du Clic chantent votre venue !",
		"dimensions": "Vos clics résonnent à travers les dimensions...",
		"portal": "Vos clics ont ouvert un portail vers la Dimension du Clic !",
		"sacrifice": "Les anciens Dieux du Clic exigent PLUS DE SACRIFICES",
		"jackpot": "JACKPOT ! Le Casino du Clic accueille son nouveau champion !",
		"unmatched": "你的点击力量无人能及! (Votre puissance de clic est inégalée !)",
		"reality": "La réalité elle-même se plie à votre volonté de clic !",
		"elite": "VOUS ÊTES DEVENU LE MAÎTRE DU CLIC D'ÉLITE",
		"power": "Votre niveau de puissance de clic dépasse 1500 !",
		"devils": "Les Démons du Clic s'inclinent devant votre puissance",
		"lucky": "Les clics chanceux coulent dans vos veines",
		"dynasty": "La Dynastie du Clic reconnaît votre suprématie",
		"twoThousand": "Deux mille clics de pure puissance !",
		"quartet": "La prophétie du Quatuor du Clic est accomplie",
		"transcend": "Vos clics transcendent la compréhension mortelle",
		"constellation": "La Constellation du Clic s'aligne en votre honneur",
		"destiny": "TROIS MILLE CLICS DU DESTIN",
		"triforce": "La Triple Triforce du Clic s'éveille !",
		"fortune": "La fortune favorise le cliqueur persistant",
		"newDimensions": "Votre puissance de clic atteint de nouvelles dimensions",
		"quartet2": "Le Quatuor Quadruple du Clic s'harmonise",
		"threshold": "Debout au seuil de la divinité du clic",
		"ultimate": "CINQ MILLE CLICS DE PUISSANCE ULTIME !",
		"force": "La Force des Cinq Doigts du Clic est à vos ordres",
		"underworld": "Les Enfers du Clic vous couronnent leur souverain",
		"maxJackpot": "JACKPOT MAXIMUM DE CLIC ATTEINT",
		"infinite": "无限点击力量! (PUISSANCE DE CLIC INFINIE !)",
		"godhood": "VOUS AVEZ ATTEINT LA DIVINITÉ DU CLIC",
		"burrow": "Vous avez creusé plus profond qu'aucun lapin avant vous...",
		"warren": "Le Grand Terrier reconnaît votre présence...",
		"thump": "La terre tremble à chaque coup de votre patte !",
		"darkWarren": "Le Terrier Sombre ouvre ses portes pour vous...",
		"ears": "Vos oreilles s'allongent... vous pouvez tout entendre maintenant...",
		"carrotThrone": "Le Trône de Carotte se matérialise devant vous...",
		"onesAlignment": "Tous les uns s'alignent - la Fréquence du Terrier résonne !",
		"moonSummon": "Le Lapin Lunaire entend votre appel à travers le vide...",
		"edgeOfForever": "Vous êtes au bord de l'éternité... oreilles frémissantes...",
		"beyondTheVeil": "Au-delà du voile, tous les terriers ne font qu'un...",
		"sequence": "1-2-3-4-5... La Séquence Sacrée du Bond est complète !",
		"hyperElite": "STATUT HYPER ÉLITE DÉBLOQUÉ 🐇🐇🐇",
		"eventHorizon": "Au-delà de l'horizon des événements du Terrier Cosmique...",
		"matrixAwakens": "La Matrice du Terrier glitche... vous voyez les carottes derrière la réalité",
		"luckyForever": "Chaque patte, chaque bond, chaque frémissement... béni pour toujours",
		"twentyK": "VINGT MILLE. Vous n'êtes plus un lapin. Vous êtes LE lapin.",
		"singularity": "La Singularité Lapine. Tous les lapins sont vous. Vous êtes tous les lapins.",
		"tripleAscension": "La Triple Ascension du Lièvre Cosmique !",
		"ultimateAnswer": "42 000 - La Réponse Ultime, c'était les carottes depuis le début",
		"eternity": "♾️ LE TERRIER ÉTERNEL N'A PAS DE FIN. VOUS NON PLUS. ♾️"
	},
	"powerups": {
		"bonusPoints": "🥕 +{{count}} Points Bonus !",
		"clickStreak": "🔥 {{count}} Clics d'Affilée !",
		"fire": "🔥 Puissance de Feu Activée !"
	},
	"table": {
		"achievement": "Succès",
		"progress": "Progrès"
	},
	"reset": {
		"confirm": "Êtes-vous sûr de vouloir réinitialiser toute la progression ? Cette action est irréversible."
	}
}
